import { render, staticRenderFns } from "./ResetPasswordValidation.vue?vue&type=template&id=a7c56694&"
import script from "./ResetPasswordValidation.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordValidation.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordValidation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports